'use client'

import { Builder } from '@builder.io/react'

import { QuoteReviews } from './QuoteReviews'
import { defaultProps } from './QuoteReviews.defaults'

Builder.registerComponent(QuoteReviews, {
  name: 'QuoteReviews',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: defaultProps.backgroundColor,
    },
    {
      name: 'mainQuoteColor',
      type: 'color',
      defaultValue: defaultProps.mainQuoteColor,
    },
    {
      name: 'secondaryQuoteColor',
      type: 'color',
      defaultValue: defaultProps.secondaryQuoteColor,
    },
    {
      name: 'alignment',
      type: 'text',
      defaultValue: defaultProps.alignment,
      enum: ['center', 'auto'],
    },
    {
      name: 'reviews',
      type: 'list',
      defaultValue: defaultProps.reviews,
      subFields: [
        {
          name: 'mainQuote',
          type: 'string',
          defaultValue: '“Hot flashes are gone”',
        },
        {
          name: 'secondaryQuote',
          type: 'string',
          defaultValue: '~ Jessica C.',
        },
        {
          name: 'imageQuoteUrl',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
          defaultValue: '/images/stars-bv.svg',
        },
        {
          name: 'imageQuoteAlt',
          type: 'string',
          defaultValue: '',
        },
        {
          name: 'thumbnailUrl',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
          defaultValue: '/images/quote-reviews-thumb.svg',
        },
        {
          name: 'thumbnailAlt',
          type: 'string',
          defaultValue: '',
        },
      ],
    },
  ],
})
